import { render, staticRenderFns } from "./CalloutCard.vue?vue&type=template&id=acff6092&"
import script from "./CalloutCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CalloutCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports